export enum SnackbarTypeEnum {
	SUCCESS = 'success',
	INFO = 'info',
	WARNING = 'warning',
	DANGER = 'danger',
}

interface ISnackbarActioin {
	actionText: string;
	onClick?: () => void;
}
export interface ISnackbar {
	type: SnackbarTypeEnum;
	text?: string;
	customContent?: JSX.Element;
	action?: ISnackbarActioin;
	delayClose?: number;
	autoClose?: boolean;
}
